/* Serial Seal CARD CASE BUILDER (2026-10-06): cards / top loaders / one-touch / slabs / sealed packs / bays -> the smallest
   printable case that holds them -> top view, 3D, price, add to cart (custom-card-case variant at or above the quote).
   Mobile first. Dimensions are nominal (published sizes + clearance) and live in CAT / K. Config: window.CC_CFG (cc-builder.liquid). */
(function () {
  'use strict';
  var root = document.querySelector('[data-cc-builder]');
  if (!root) return;
  var CFG = window.CC_CFG || {};

  // ---------- catalog (mm). rows: w = face width across the row, h = standing height, t = thickness per item ----------
  var CAT = {
    cards: [
      {id: 'raw', name: 'Cards, no sleeve', w: 63, h: 88, t: 0.31},
      {id: 'penny', name: 'Penny sleeved', w: 66, h: 91, t: 0.38},
      {id: 'deck', name: 'Deck-protector sleeved', w: 67, h: 92, t: 0.45},
      {id: 'double', name: 'Double sleeved', w: 68, h: 94, t: 0.58},
      {id: 'jp', name: 'Japanese size, sleeved', w: 62, h: 89, t: 0.40},
      {id: 'tl35', name: 'Top loader 3x4 (35pt)', w: 77, h: 102, t: 1.6},
      {id: 'saver', name: 'Card Saver (semi-rigid)', w: 89, h: 124, t: 1.3},
      {id: 'mag35', name: 'Magnetic one-touch 35pt', w: 87, h: 112, t: 6.6},
      {id: 'mag130', name: 'Magnetic one-touch 130pt', w: 87, h: 112, t: 9.6}
    ],
    slabs: [
      {id: 'psa', name: 'PSA slab', w: 81, h: 136, t: 6.6},
      {id: 'bgs', name: 'BGS slab', w: 83, h: 140, t: 9.8},
      {id: 'cgc', name: 'CGC slab', w: 80, h: 136, t: 7.6},
      {id: 'sgc', name: 'SGC slab', w: 78, h: 133, t: 7.8},
      {id: 'slabx', name: 'Other slab (custom size)', w: 82, h: 138, t: 8}
    ],
    sealed: [
      {id: 'pack', name: 'Booster packs', w: 75, h: 134, t: 3.6, row: true},
      {id: 'deckbox', name: 'Deck box (100 card)', bw: 82, bd: 76, bh: 96},
      {id: 'dice', name: 'Dice / counters tray', bw: 70, bd: 45, bh: 25},
      {id: 'custom', name: 'Custom bay', bw: 80, bd: 60, bh: 40}
    ]
  };
  var K = {
    rowClear: 2.0, divider: 1.6, rowSlack: 4,          // row inner = item width + 2; 1.6 dividers; 4 mm of slack per row
    slotClear: 1.0, bayClear: 2.0, gap: 2.0,
    wall: 3.5, hingeLatch: 10, floor: 3, lidTop: 3, headroom: 2, lidDepth: 15,
    std: {w: 246, d: 236, h: 240, name: 'Standard build'}, xl: {w: 335, d: 305, h: 300, name: 'XL build'},
    caps: [70, 90, 110, 130, 150, 170, 190, 210, 230, 250, 270, 285]       // row / slot-column lengths tried along the depth
  };

  var S = {color: (CFG.colors && CFG.colors[0] && CFG.colors[0].name) || 'Midnight Black', items: []};
  function find(kind, id) { return CAT[kind].filter(function (x) { return x.id === id; })[0]; }
  function load() {
    try {
      var h = decodeURIComponent((location.hash || '').replace(/^#case=/, ''));
      if (h && h.charAt(0) === '{') { var o = JSON.parse(h); if (o && o.items) S = o; }
    } catch (e) {}
    if (!S.items.length) S.items = [{kind: 'cards', id: 'penny', qty: 400}, {kind: 'slabs', id: 'psa', qty: 6}];
  }
  function save() { try { history.replaceState(null, '', '#case=' + encodeURIComponent(JSON.stringify(S))); } catch (e) {} }

  function dims(it) {
    var c = find(it.kind, it.id);
    if (it.kind === 'sealed' && it.id === 'custom') c = {name: 'Custom bay', bw: +it.w || 80, bd: +it.d || 60, bh: +it.h || 40};
    if (it.kind === 'slabs' && it.id === 'slabx') c = {name: 'Custom slab', w: +it.w || 82, h: +it.h || 138, t: +it.t || 8};
    return c;
  }
  function isRow(it, c) { return it.kind === 'cards' || it.kind === 'slabs' || (c && c.row); }
  function needH(it) { var c = dims(it); return (isRow(it, c) ? c.h : c.bh) + K.headroom; }
  function summary() { return S.items.map(function (it) { return it.qty + ' x ' + dims(it).name; }).join(', '); }

  // ---------- planning ----------
  function blocksFor(cap) {
    var out = [];
    S.items.forEach(function (it, k) {
      var c = dims(it), q = Math.max(0, it.qty | 0);
      if (!q) return;
      if (isRow(it, c)) {
        var slab = it.kind === 'slabs';
        var pitch = slab ? c.t + K.slotClear + K.divider : c.t;              // slabs get a divider each; cards stack
        var lane = c.w + K.rowClear;                                          // inner width of one row / slot column
        var room = cap - (slab ? K.divider : K.rowSlack);
        var per = Math.max(1, Math.floor(room / pitch));
        var lanes = Math.ceil(q / per);
        per = Math.ceil(q / lanes);
        var len = slab ? per * pitch + K.divider : per * pitch + K.rowSlack;
        out.push({k: k, type: slab ? 'slabs' : 'cards', c: c, q: q, lanes: lanes, per: per, pitch: pitch, lane: lane,
          w: lanes * (lane + K.divider) + K.divider, d: len + 2 * K.divider, canRot: true});
      } else {
        for (var i = 0; i < q; i++) out.push({k: k, type: 'bay', c: c, q: 1, w: c.bw + 2 * K.bayClear, d: c.bd + 2 * K.bayClear, canRot: true});
      }
    });
    return out;
  }
  function shelf(blocks, X, orient) {
    var B = blocks.map(function (b) {
      var o = Object.assign({}, b);
      var flip = o.canRot && ((o.w > X && o.d <= X) || (orient === 'wide' && o.d > o.w && o.d <= X) || (orient === 'deep' && o.w > o.d && o.d <= X));
      if (flip) { var t = o.w; o.w = o.d; o.d = t; o.rot = !o.rot; }
      return o;
    });
    if (B.some(function (b) { return b.w > X + 0.01; })) return null;
    B.sort(function (a, b) { return b.d - a.d || b.w - a.w; });
    var rows = [], y = 0;
    B.forEach(function (b) {
      for (var r = 0; r < rows.length; r++) {
        var R = rows[r], alt = b.canRot ? Object.assign({}, b, {w: b.d, d: b.w, rot: !b.rot}) : null;
        var fit = function (bb) { return R.x + K.gap + bb.w <= X + 0.01 && bb.d <= R.h + 0.01; };
        var pick = fit(b) ? b : (alt && fit(alt) ? alt : null);
        if (pick) { pick.x = R.x + K.gap; pick.y = R.y; R.x = pick.x + pick.w; R.items.push(pick); return; }
      }
      var ny = rows.length ? y + K.gap : 0;
      b.x = 0; b.y = ny; rows.push({y: ny, h: b.d, x: b.w, items: [b]}); y = ny + b.d;
    });
    var W = 0, all = [];
    rows.forEach(function (R) { W = Math.max(W, R.x); R.items.forEach(function (b) { all.push(b); }); });
    return {W: W, D: y, blocks: all};
  }
  function plan() {
    var Hin = 0;
    S.items.forEach(function (it) { if ((it.qty | 0) > 0) Hin = Math.max(Hin, needH(it)); });
    if (!Hin) return null;
    var Ho = Hin + K.floor + K.lidTop, best = null;
    K.caps.forEach(function (cap) {
      var blocks = blocksFor(cap);
      var minX = 30;
      blocks.forEach(function (b) { minX = Math.max(minX, b.canRot ? Math.min(b.w, b.d) : b.w); });
      for (var X = Math.ceil(minX); X <= K.xl.w - 2 * K.wall; X += 2) {
        ['keep', 'wide', 'deep'].forEach(function (orient) {
          var r = shelf(blocks, X, orient);
          if (!r) return;
          var Wo = r.W + 2 * K.wall, Do = r.D + 2 * K.wall + K.hingeLatch;
          var aspect = Math.max(Wo, Do) / Math.min(Wo, Do);
          var score = Wo * Do * (aspect > 2.2 ? 1 + (aspect - 2.2) * 0.25 : 1);
          var std = Wo <= K.std.w && Do <= K.std.d && Ho <= K.std.h, xl = Wo <= K.xl.w && Do <= K.xl.d && Ho <= K.xl.h;
          score *= std ? 1 : (xl ? 1.6 : 25);
          if (!best || score < best.score - 1) best = {score: score, r: r};
        });
      }
    });
    if (!best) return {tooBig: true, Hin: Hin};
    var Wo2 = best.r.W + 2 * K.wall, Do2 = best.r.D + 2 * K.wall;
    var plate = (Wo2 <= K.std.w && Do2 + K.hingeLatch <= K.std.d && Ho <= K.std.h) ? 'std' :
                (Wo2 <= K.xl.w && Do2 + K.hingeLatch <= K.xl.d && Ho <= K.xl.h) ? 'xl' : 'big';
    return {Wi: best.r.W, Di: best.r.D, Hin: Hin, Wo: Wo2, Do: Do2, Ho: Ho, blocks: best.r.blocks, plate: plate};
  }
  function price(P) {
    if (!P || P.tooBig) return null;
    var shell = 2 * P.Wo * P.Do * K.floor + 2 * (P.Wo + P.Do) * P.Ho * 2.4;
    var inner = P.blocks.reduce(function (a, b) {
      return a + (b.type === 'bay' ? 0 : (b.lanes + 1) * (b.type === 'slabs' ? b.d : b.d) * P.Hin * 0.55 * K.divider + (b.type === 'slabs' ? b.per * b.lanes * b.lane * P.Hin * 0.35 * K.divider : 0));
    }, 0);
    var grams = (shell + inner) / 1000 * 1.24;
    var raw = (CFG.price_base || 22) + grams * (CFG.price_per_gram || 0.085) + (P.plate === 'xl' ? (CFG.price_xl || 15) : 0);
    return {grams: Math.round(grams), cents: Math.round((Math.max(CFG.price_min || 29, Math.ceil(raw)) - 0.01) * 100)};
  }

  // ---------- UI ----------
  var $ = function (s) { return root.querySelector(s); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  function populate() {
    ['cards', 'slabs', 'sealed'].forEach(function (kind) {
      var sel = root.querySelector('[data-pick="' + kind + '"]');
      sel.innerHTML = CAT[kind].map(function (c) { return '<option value="' + c.id + '">' + c.name + '</option>'; }).join('');
    });
    $('[data-colors]').innerHTML = (CFG.colors || []).map(function (c, i) {
      return '<input type="radio" name="ccColor" id="ccc' + i + '" value="' + c.name + '"' + (c.name === S.color ? ' checked' : '') + '>' +
        '<label for="ccc' + i + '"><i style="background:' + c.hex + '"></i>' + c.name + '</label>';
    }).join('');
  }
  function listHtml() {
    if (!S.items.length) return '<p class="ccb-note">Nothing added yet.</p>';
    return S.items.map(function (it, i) {
      var c = dims(it), row = isRow(it, c), step = it.kind === 'cards' && c.t < 1 ? 50 : 1;
      var sub = row ? (it.kind === 'slabs' ? Math.round(c.w) + ' x ' + Math.round(c.h) + ' x ' + c.t + ' mm' :
        Math.round(c.w) + ' x ' + Math.round(c.h) + ' mm, ' + c.t + ' mm each') : c.bw + ' x ' + c.bd + ' x ' + c.bh + ' mm';
      return '<div class="ccb-row"><div><b>' + c.name + '</b><span>' + sub + '</span></div>' +
        '<div class="ccb-qty"><button type="button" data-step="' + i + '" data-d="-' + step + '" aria-label="Fewer">&minus;</button>' +
        '<input type="number" inputmode="numeric" min="0" value="' + it.qty + '" data-set="' + i + '" aria-label="How many ' + c.name + '">' +
        '<button type="button" data-step="' + i + '" data-d="' + step + '" aria-label="More">+</button></div>' +
        '<button type="button" class="ccb-x" data-del="' + i + '" aria-label="Remove ' + c.name + '">&times;</button></div>';
    }).join('');
  }
  function topSvg(P) {
    if (!P) return '<p class="ccb-note" style="padding:28px;text-align:center">Add cards, slabs or packs to see your case.</p>';
    if (P.tooBig || P.plate === 'big') return '<p class="ccb-note" style="padding:28px;text-align:center">That is more than one case can hold - remove some or build two cases.</p>';
    var pad = 12, W = P.Wo, D = P.Do, s = [], c = 6;
    s.push('<svg viewBox="' + (-pad) + ' ' + (-pad) + ' ' + (W + pad * 2) + ' ' + (D + pad * 2 + 16) + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Top view of your case">');
    s.push('<defs><linearGradient id="ccHolo" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#7de3ff"/><stop offset=".35" stop-color="#9a8cff"/><stop offset=".65" stop-color="#ff7ad9"/><stop offset="1" stop-color="#ffd36e"/></linearGradient></defs>');
    s.push('<polygon points="' + [c + ',0', (W - c) + ',0', W + ',' + c, W + ',' + (D - c), (W - c) + ',' + D, c + ',' + D, '0,' + (D - c), '0,' + c].join(' ') + '" fill="#12151d" stroke="url(#ccHolo)" stroke-width="1.4"/>');
    s.push('<rect x="' + K.wall + '" y="' + K.wall + '" width="' + P.Wi + '" height="' + P.Di + '" fill="#07080c" stroke="#232836" stroke-width=".6"/>');
    P.blocks.forEach(function (b) {
      var x0 = K.wall + b.x, y0 = K.wall + b.y;
      if (b.type === 'bay') {
        s.push('<rect x="' + (x0 + 1) + '" y="' + (y0 + 1) + '" width="' + (b.w - 2) + '" height="' + (b.d - 2) + '" rx="2" fill="#0b0d12" stroke="#9a8cff" stroke-width=".7" stroke-dasharray="3 2"/>');
        s.push('<text x="' + (x0 + b.w / 2) + '" y="' + (y0 + b.d / 2 + 3) + '" fill="#8b93a8" font-size="' + Math.max(5.5, Math.min(9, b.w / 11)) + '" text-anchor="middle" font-family="monospace">' + b.c.name.toUpperCase() + '</text>');
        return;
      }
      for (var l = 0; l < b.lanes; l++) {
        var n = Math.min(b.per, b.q - l * b.per); if (n <= 0) break;
        var fill = b.type === 'slabs' ? b.per * b.pitch : n * b.pitch;
        var lx, ly, lw, ld;
        if (!b.rot) { lx = x0 + K.divider + l * (b.lane + K.divider); ly = y0 + K.divider; lw = b.lane; ld = b.d - 2 * K.divider; }
        else { lx = x0 + K.divider; ly = y0 + K.divider + l * (b.lane + K.divider); lw = b.w - 2 * K.divider; ld = b.lane; }
        s.push('<rect x="' + lx.toFixed(1) + '" y="' + ly.toFixed(1) + '" width="' + lw.toFixed(1) + '" height="' + ld.toFixed(1) + '" fill="#0b0d12" stroke="#2c3244" stroke-width=".5"/>');
        if (b.type === 'slabs') {
          for (var k = 0; k < n; k++) {
            var o = K.divider + k * b.pitch;
            if (!b.rot) s.push('<rect x="' + (lx + 1).toFixed(1) + '" y="' + (ly + o).toFixed(1) + '" width="' + (lw - 2).toFixed(1) + '" height="' + (b.c.t).toFixed(1) + '" fill="#1b2030" stroke="url(#ccHolo)" stroke-width=".5"/>');
            else s.push('<rect x="' + (lx + o).toFixed(1) + '" y="' + (ly + 1).toFixed(1) + '" width="' + (b.c.t).toFixed(1) + '" height="' + (ld - 2).toFixed(1) + '" fill="#1b2030" stroke="url(#ccHolo)" stroke-width=".5"/>');
          }
        } else {
          var used = Math.min(fill, (b.rot ? lw : ld) - 2);
          if (!b.rot) s.push('<rect x="' + (lx + 1).toFixed(1) + '" y="' + (ly + 1).toFixed(1) + '" width="' + (lw - 2).toFixed(1) + '" height="' + used.toFixed(1) + '" fill="url(#ccHolo)" opacity=".28"/>');
          else s.push('<rect x="' + (lx + 1).toFixed(1) + '" y="' + (ly + 1).toFixed(1) + '" width="' + used.toFixed(1) + '" height="' + (ld - 2).toFixed(1) + '" fill="url(#ccHolo)" opacity=".28"/>');
          var lines = Math.min(24, Math.floor(used / 3));
          for (var j = 1; j <= lines; j++) {
            var p = 1 + used * j / (lines + 1);
            if (!b.rot) s.push('<line x1="' + (lx + 2) + '" x2="' + (lx + lw - 2) + '" y1="' + (ly + p).toFixed(1) + '" y2="' + (ly + p).toFixed(1) + '" stroke="#c9b8ff" stroke-width=".25" opacity=".55"/>');
            else s.push('<line y1="' + (ly + 2) + '" y2="' + (ly + ld - 2) + '" x1="' + (lx + p).toFixed(1) + '" x2="' + (lx + p).toFixed(1) + '" stroke="#c9b8ff" stroke-width=".25" opacity=".55"/>');
          }
        }
      }
    });
    s.push('<text x="' + (W / 2) + '" y="' + (D + 13) + '" fill="#8b93a8" font-size="8.5" text-anchor="middle" font-family="monospace">' + Math.round(P.Wo) + ' x ' + Math.round(P.Do + K.hingeLatch) + ' mm - hinge at the top</text></svg>');
    return s.join('');
  }
  var lastPlan = null;
  function live() { return !!(CFG.publishedAt && CFG.variants && CFG.variants.length); }
  function pickVariant(cents) {
    if (!live()) return null;
    return CFG.variants.filter(function (x) { return x.available && x.price >= cents; }).sort(function (a, b) { return a.price - b.price; })[0] ||
           CFG.variants.slice().sort(function (a, b) { return b.price - a.price; })[0];
  }
  function render() {
    S.items = S.items.filter(function (x) { return (x.qty | 0) > 0; });
    $('[data-list]').innerHTML = listHtml();
    var P = plan(); lastPlan = P;
    $('[data-top]').innerHTML = topSvg(P);
    var pr = price(P), st = $('[data-stats]'), ok = P && !P.tooBig && P.plate !== 'big';
    if (!ok) st.innerHTML = '';
    else {
      var inch = function (mm) { return (mm / 25.4).toFixed(1); };
      st.innerHTML = '<dl class="ccb-specs"><dt>Case</dt><dd>' + Math.round(P.Wo) + ' x ' + Math.round(P.Do + K.hingeLatch) + ' x ' + Math.round(P.Ho) + ' mm <span>(' +
        inch(P.Wo) + ' x ' + inch(P.Do + K.hingeLatch) + ' x ' + inch(P.Ho) + ' in)</span></dd><dt>Holds</dt><dd>' + summary() + '</dd><dt>Color</dt><dd>' + S.color + '</dd></dl>';
    }
    var pv = ok && pr ? pickVariant(pr.cents) : null;      // show what the cart will charge (the price step at or above the quote)
    $('[data-price]').textContent = ok && pr ? money(pv ? pv.price : pr.cents) : '--';
    var btn = $('[data-atc]');
    btn.disabled = !ok || !pr || !live();
    btn.textContent = live() ? 'Add to cart' : 'Coming soon';
    save();
    if (window.CC3D) window.CC3D.update(P, colorHex());
  }
  function colorHex() { var c = (CFG.colors || []).filter(function (x) { return x.name === S.color; })[0]; return c ? c.hex : '#16181f'; }
  function addItem(kind) {
    var id = root.querySelector('[data-pick="' + kind + '"]').value;
    var q = Math.max(1, parseInt(root.querySelector('[data-qty-add="' + kind + '"]').value, 10) || 1);
    var it = {kind: kind, id: id, qty: q};
    if (kind === 'sealed' && id === 'custom') { it.w = +$('[data-cw]').value || 80; it.d = +$('[data-cd]').value || 60; it.h = +$('[data-ch]').value || 40; }
    else if (kind === 'slabs' && id === 'slabx') { it.w = +$('[data-sw]').value || 82; it.h = +$('[data-sh]').value || 138; it.t = +$('[data-st]').value || 8; }
    else { var same = S.items.filter(function (x) { return x.kind === kind && x.id === id; })[0]; if (same) { same.qty += q; render(); return; } }
    S.items.push(it); render();
  }
  function toast(m) {
    var t = $('[data-toast]'); t.textContent = m; t.classList.add('on'); clearTimeout(toast.t); toast.t = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }
  function addToCart() {
    var P = lastPlan, pr = price(P); if (!pr || !live()) return;
    var v = pickVariant(pr.cents);
    var btn = $('[data-atc]'); btn.disabled = true;
    fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: [{id: v.id, quantity: 1, properties: {
        'Holds': summary(), 'Case size': Math.round(P.Wo) + ' x ' + Math.round(P.Do + K.hingeLatch) + ' x ' + Math.round(P.Ho) + ' mm', 'Color': S.color,
        '_spec': JSON.stringify(S), '_plate': P.plate, '_quote': money(pr.cents)}}]})})
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { toast('Case added to your cart'); document.dispatchEvent(new CustomEvent('cart:refresh')); if (CFG.cartUrl) setTimeout(function () { location.href = CFG.cartUrl; }, 700); })
      .catch(function () { toast('Could not add it - try again'); })
      .finally(function () { btn.disabled = false; });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button'); if (!t) return;
    if (t.hasAttribute('data-add')) addItem(t.getAttribute('data-add'));
    else if (t.hasAttribute('data-step')) { var it = S.items[+t.getAttribute('data-step')]; it.qty = Math.max(0, it.qty + (+t.getAttribute('data-d'))); render(); }
    else if (t.hasAttribute('data-del')) { S.items.splice(+t.getAttribute('data-del'), 1); render(); }
    else if (t.hasAttribute('data-tab')) {
      root.querySelectorAll('[data-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === t ? 'true' : 'false'); });
      root.querySelectorAll('[data-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== t.getAttribute('data-tab'); });
    } else if (t.hasAttribute('data-view')) {
      root.querySelectorAll('[data-view]').forEach(function (b) { b.setAttribute('aria-selected', b === t ? 'true' : 'false'); });
      var v = t.getAttribute('data-view'); $('[data-top]').hidden = v !== 'top'; $('[data-3d]').hidden = v !== '3d';
      if (v === '3d' && window.CC3D) window.CC3D.show(lastPlan, colorHex());
    } else if (t.hasAttribute('data-atc')) addToCart();
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'ccColor') { S.color = t.value; render(); }
    if (t.hasAttribute('data-set')) { S.items[+t.getAttribute('data-set')].qty = Math.max(0, parseInt(t.value, 10) || 0); render(); }
    if (t.matches('[data-pick="sealed"]')) $('[data-custom]').hidden = t.value !== 'custom';
    if (t.matches('[data-pick="slabs"]')) $('[data-slabx]').hidden = t.value !== 'slabx';
  });

  window.CCB = {plan: plan, price: price, K: K, state: function () { return S; },
    test: function (items) { var keep = S.items; S.items = items; var P = plan(), pr = price(P); S.items = keep; return {P: P, price: pr}; }};
  load(); populate(); render();
})();
